<template>
    <div>
        <b-modal size="xl" id="modal-prevent-closing" centered class="header-modal" no-close-on-backdrop hide-footer ref="modal-view-file">
            <div class="modal-view-file__body container wrap-form-create-update-chapter">
                <ViewFile :path="path" />
                <div class="modal__actions text-right">
                    <a href="javascript:;" class="primary-color-txt font-size-17 btn-cancel" @click="handleHideModal">
                        Đóng
                        <img class="icon-close" src="@/assets/img/x.png" alt="" />
                    </a>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import ViewFile from './ViewFile'

export default {
    components: {
        ViewFile
    },
    props: {
        path: {
            type: String,
            default: ''
        },
    },
    mounted() {
        this.handleShowModal()
    },
    methods: {
        handleHideModal() {
            this.$emit('closeModal')
        },
        handleShowModal() {
            this.$refs['modal-view-file'].show()
        },
    }
}
</script>

<style lang="scss" scoped>
.modal-view-file__body{
    height: calc(100vh - 20rem);
    .modal__actions {
    position: absolute;
    top: 0px;
    right: 5px;
    padding: 0px;
   

    .icon-close {
        width: 15px !important;
    }
}
}

</style>